// import { mutationFixedCacheKeys } from "./endpoints"

import { RootState } from 'src/redux/root'

export const selectAuthorized = (state: RootState) => {
  if (state.user.session) {
    return true
  } else {
    return false
  }
}
// ![null, false, undefined].includes(state.user.session)
export const selectSession = (state: RootState) => state.user.session
export const selectUserId = (state: RootState) => state.user.session?.user?.id

export const selectActiveOrganization = (state: RootState) => state.user.activeOrganization

export const isLoading = (state: RootState) => {
  return false
}
